import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function NoPermissionPage({ showLoginLink = true }) {
  return (
    <Box sx={{ py: 8, textAlign: 'center' }}>
      <Typography variant="h4" gutterBottom>
        Permission Denied
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        You do not have permission to view this page.
      </Typography>
      {showLoginLink && (
        <Typography variant="body2">
          <Link
            component={RouterLink}
            to="/sign-in"
            underline="hover"
            color="primary"
            fontWeight="bold"
            sx={{ mr: 1 }}
          >
            Log in
          </Link>
          or
          <Link
            component={RouterLink}
            to="/"
            underline="hover"
            color="primary"
            fontWeight="bold"
            sx={{ ml: 1 }}
          >
            go to home page
          </Link>
        </Typography>
      )}
    </Box>
  );
}
